import React from "react"
import { useTranslation } from "react-i18next"

function OurLocation() {
  const { t } = useTranslation()
  return (
    <div className="uk-container uk-margin-large-bottom">
      <h1 className="uk-text-bold uk-text-center">
        {t("ourprogram.ourLocation")}
      </h1>
      <div style={{ fontSize: 18 }} className="uk-article ">
        <p>{t("ourprogram.ourLocationDesc")}</p>
      </div>
    </div>
  )
}

export default OurLocation
